import { memo } from 'react'


const AuctionInsights = memo(() => {

    return(
        <div className="mt-5">
            <h1>Campaign / media-buying / Insights / Auction insights</h1>
        </div>
    )

})


export default AuctionInsights